<onsip-loading-container
  [deferCond]="initLoaded$"
  [loadingMessage]="
    (loadingStateComplete$ | async) === false
      ? 'ONSIP_I18N.SAVING_CHANGES'
      : 'ONSIP_I18N.PLEASE_WAIT_SECONDS'
  "
>
  <form [formGroup]="blockedNumberForm" (ngSubmit)="onSubmit()">
    <div class="mat-headline-5">Blocked numbers</div>
    <div class="onsip-grid-placement">
      <div class="first-column">
        <div class="mat-body-1 property-header">Add a number</div>
        <mat-form-field
          appearance="outline"
          onsip-form-field-flush-outline
          class="country-select-field"
        >
          <mat-select formControlName="country">
            @for (countryCodeObj of countryCodeList; track countryCodeObj) {
            <mat-option [value]="countryCodeObj.country">
              {{ countryCodeObj.country }}
            </mat-option>
            }
          </mat-select>
        </mat-form-field>
        <mat-form-field appearance="outline" class="form-field">
          <input
            matInput
            #phoneNumber
            type="text"
            formControlName="phoneNumber"
            name="phoneNumber"
          />
          @if (blockedNumberForm.controls['phoneNumber'].hasError('validPhoneNumber')) {
          <mat-error>
            {{ "ONSIP_I18N.MUST_BE_A_VALID_PHONE_NUMBER" | translate }}
          </mat-error>
          } @if (blockedNumberForm.controls['phoneNumber'].hasError('required')) {
          <mat-error>
            {{ "ONSIP_I18N.PHONE_NUMBER_IS_REQUIRED" | translate }}
          </mat-error>
          }
        </mat-form-field>
        <div class="controls">
          <button class="submit-btn block-number-btn" mat-flat-button color="primary">
            Block number
          </button>
        </div>
      </div>
      @if (blockedNumbersList.length > 0) {
      <div class="second-column">
        <div class="mat-body-1 property-header blocked-num-header">Blocked numbers</div>
        @if (this.splitNumbers && blockedNumbersList.length > initBlockedColMax) {
        <div>
          @if (blockedNumbersList.length <= initBlockedColMax * 2) {
          <div class="blocked-num-grid">
            <div class="blocked-first-col">
              @for (blockedNum of blockedNumbersList.slice(0, initBlockedColMax); track blockedNum)
              {
              <div>
                <div class="blocked-num-container">
                  <div class="blocked-num">
                    {{ blockedNum.e164Number | e164 }}
                  </div>
                  <button
                    mat-icon-button
                    (click)="handleDelete(blockedNum)"
                    class="delete-button"
                    color="primary"
                    type="button"
                  >
                    <mat-icon class="delete-icon">delete</mat-icon>
                  </button>
                </div>
              </div>
              }
            </div>
            <div class="blocked-second-col">
              @for (blockedNum of blockedNumbersList.slice(initBlockedColMax); track blockedNum) {
              <div>
                <div class="blocked-num-container">
                  <div class="blocked-num">
                    {{ blockedNum.e164Number | e164 }}
                  </div>
                  <button
                    mat-icon-button
                    (click)="handleDelete(blockedNum)"
                    class="delete-button"
                    color="primary"
                    type="button"
                  >
                    <mat-icon class="delete-icon">delete</mat-icon>
                  </button>
                </div>
              </div>
              }
            </div>
          </div>
          } @if (blockedNumbersList.length > initBlockedColMax * 2) {
          <div>
            @for (blockedNum of blockedNumbersList.slice(0, initBlockedColMax); track blockedNum;
            let i = $index) {
            <div [attr.data-index]="i" class="blocked-num-grid">
              <div class="blocked-first-col">
                <div class="blocked-num-container">
                  <div class="blocked-num">
                    {{ blockedNum.e164Number | e164 }}
                  </div>
                  <button
                    mat-icon-button
                    (click)="handleDelete(blockedNum)"
                    class="delete-button"
                    color="primary"
                    type="button"
                  >
                    <mat-icon class="delete-icon">delete</mat-icon>
                  </button>
                </div>
              </div>
              <div class="blocked-second-col">
                <div class="blocked-num-container">
                  <div class="blocked-num">
                    {{ blockedNumbersList[i + initBlockedColMax].e164Number | e164 }}
                  </div>
                  <button
                    mat-icon-button
                    (click)="handleDelete(blockedNumbersList[i + initBlockedColMax])"
                    class="delete-button"
                    color="primary"
                    type="button"
                  >
                    <mat-icon class="delete-icon">delete</mat-icon>
                  </button>
                </div>
              </div>
            </div>
            } @for ( blockedNum of blockedNumbersList.slice(initBlockedColMax * 2); track
            blockedNum; let i = $index) {
            <div [attr.data-index]="i">
              @if (i % 2 === 0) {
              <div class="blocked-num-grid">
                <div class="blocked-first-col">
                  <div class="blocked-num-container">
                    <div class="blocked-num">
                      {{ blockedNum.e164Number | e164 }}
                    </div>
                    <button
                      mat-icon-button
                      (click)="handleDelete(blockedNum)"
                      class="delete-button"
                      color="primary"
                      type="button"
                    >
                      <mat-icon class="delete-icon">delete</mat-icon>
                    </button>
                  </div>
                </div>
                @if (i + 1 < blockedNumbersList.slice(initBlockedColMax * 2).length) {
                <div class="blocked-second-col">
                  <div class="blocked-num-container">
                    <div class="blocked-num">
                      {{ blockedNumbersList.slice(initBlockedColMax * 2)[i + 1].e164Number | e164 }}
                    </div>
                    <button
                      mat-icon-button
                      (click)="handleDelete(blockedNumbersList.slice(initBlockedColMax * 2)[i + 1])"
                      class="delete-button"
                      color="primary"
                      type="button"
                    >
                      <mat-icon class="delete-icon">delete</mat-icon>
                    </button>
                  </div>
                </div>
                }
              </div>
              }
            </div>
            }
          </div>
          }
        </div>
        } @if (!this.splitNumbers || blockedNumbersList.length <= initBlockedColMax) {
        <div>
          @for (blockedNum of blockedNumbersList; track blockedNum) {
          <div>
            @if (this.isMobile) {
            <div class="blocked-num-container onsip-grid-placement">
              <div class="blocked-num">
                {{ blockedNum.e164Number | e164 }}
              </div>
              <button
                mat-icon-button
                (click)="handleDelete(blockedNum)"
                class="delete-button"
                color="primary"
                type="button"
              >
                <mat-icon class="delete-icon">delete</mat-icon>
              </button>
            </div>
            } @if (!this.isMobile) {
            <div class="blocked-num-container">
              <div class="blocked-num">
                {{ blockedNum.e164Number | e164 }}
              </div>
              <button
                mat-icon-button
                (click)="handleDelete(blockedNum)"
                class="delete-button"
                color="primary"
                type="button"
              >
                <mat-icon class="delete-icon">delete</mat-icon>
              </button>
            </div>
            }
          </div>
          }
        </div>
        }
      </div>
      }
    </div>
  </form>
</onsip-loading-container>
<div class="mat-body-2 contact-support">
  {{ "ONSIP_I18N.NEED_HELP_CONTACT_OUR" | translate }}
  <a class="support-link" [routerLink]="[views.CONTACT_SUPPORT]">
    {{ "ONSIP_I18N.SUPPORT_TEAM" | translate }}
  </a>
</div>
